import { Platform } from '@angular/cdk/platform';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheet } from '../bottom.sheet';
let k=1;
@Component({
  selector: 'app-cust-item',
  templateUrl: './cust-item.component.html',
  styleUrls: ['./cust-item.component.scss'],
})
export class CustItemComponent  {
  loader: boolean = false;
  custitem:any=[];
  custitem1:any=[];
  change:boolean = true;
  custSubscriptions:any=[];
  custSubscriptionsName;
  name;
  details;
  identificationNo;
  model;
  viewBtns:boolean;
  users:any=[];Name;UserId;
  id;
  url;
  ids;
  Oid;
  clickId;
  category;
  cateName;
  cateId;
  constructor( private router: Router, private bottomSheet: MatBottomSheet,  public handler: HandlerService, private platform: Platform,
    public service: ApiService) { }

  ionViewWillEnter(){ 
    this.viewBtns= false;
    // this.change = false;
    this.loader = true;
    this.url = window.location.href;

    this.id = this.url.split('/').pop();

    sessionStorage.setItem('customerId',this.id)
    this.getCategory();

    }

    getUserId(){      
      this.service.getUserById(this.id).subscribe((res:any)=>{
        this.details=res;
        this.Oid = res.orgId;
        this.custSubscriptions=res.packageRequests;   
        this.custSubscriptions.map(res=>{     
          this.category.map(res1 => {     
            if (res1.id == res.categoryId) {
              this.cateName = res1.name;
              this.cateId = res1.id;
            }
          })
          })
          this.loader = false;
      },err =>{
        this.handler.err(err)
      })
      // this.vendoruser();
    }

  //   allcustItems(){
  //     this.loader=true;
  //     this.change=false;
  //   this.service.allcustItem().subscribe((res: any) => {
  //     if(res){
  //       this.custitem1=res;    
  //       this.custitem=this.custitem1.filter(res =>{return res.userId == this.id})
  //       this.category.map(dat=>{
  //         this.custitem.map(dat1=>{
  //           if(dat.id == dat1.itemCategoryId){
  //             Object.assign(dat1,{cateName:dat.name})
  //           }
  //         })
  //       })  
  //       this.loader = false;
  //     }else{
  //       this.loader  = false;
  //       this.handler.res("No Data Found")
  //     }
  //   },err =>{
  //     this.handler.err(err)
  //     this.loader = false;
  //   })

  // }

  getModel(data){
    if(data.custItems){
      if(data.custItems){
        return data.custItems[0].model
       
      }
    }
  }

  getService(data){
    if(data.services){
      if(data.services){
        return data.services[0].name
       
      }
    }
  }

  getId(data){
    if(data.custItems){
      if(data.custItems){
        return data.custItems[0].identificationNo
      }   
    }
  }

  // custSubscription(){
  //   this.loader = true;
  //   // this.change = true;
  //   this.service.getAllCustItemSubs().subscribe((res: any) => {
  //     if(res){
  //       this.custSubscriptions=res;
  //       this.custSubscriptions=this.custSubscriptions.filter(res =>{return res.requestorId == this.id});
  //       this.category.map(dat=>{
  //         this.custSubscriptions.map(dat1=>{
  //           if(dat.id == dat1.categoryId){
  //             Object.assign(dat1,{cateName1:dat.name})
  //           }
  //         })
  //       })  
  //        this.loader = false;
  //     }else{
  //       this.loader  = false;
  //       this.handler.res("No Data Found");
  //     }
      
  //   },err =>{
  //     this.handler.err(err)
  //     this.loader = false;
     
  //   })
  // }
  
  route(id){   
  
    this.router.navigate(['edit-cust-item/', +id]);
 
  }

  get(id,id1){

    this.router.navigate(['edit-cust-item-subs/', +id]); 
    sessionStorage.setItem('SubsId', id1)
  }

  deleteItem(id){
    this.loader=true;
    this.service.deleteCustItem(id).subscribe(res=>{
      this.loader=false;
      this.handler.res("Deleted successfully")
    this.ionViewWillEnter();
    },
    err=>{
      this.handler.err(err)
      this.loader=false
    })
  }

  deleteSubscription(id){
    this.loader=true;
    this.viewBtns = false;
    this.service.deletePackageReq(id).subscribe((res: any) => {
      this.handler.res("Subscription Cancelled successfully");
      this.loader=false;
    this.ionViewWillEnter();
    },
    err=>{
      this.handler.err(err)
      this.loader=false
    })  
  }

  getCategory(){
    this.service.getOrgCategory().subscribe((res: any) => {
      this.category=res;
      this.getUserId(); 
     
    })
  }

  // vendoruser(){
  //   this.service.getUsersByOrg('SC',this.Oid).subscribe(res => {
  //     this.users = res;
  //     this.users= this.users.filter(res =>{return res.reqRoleApproved}) 
  //   })
  // }
     
  // openBottomSheet(): void {
  //   const dialogRef = this.bottomSheet.open(BottomSheet,{
  //     data: this.users,
  //   });
  //   dialogRef.afterDismissed().subscribe(res => {
  //     if(res){
  //       this.Name = res.firstName;
  //       this.UserId=res.userId;
  //     }
  //   });
  // }  

  refreshData(event){ 
      this.ionViewWillEnter();
      setTimeout(() => {
        event.target.complete();
      }, 1000);
    }
   
    


  vendorAssign(id,item){
    this.viewBtns=false;
    this.router.navigate(['/assignVendor/', +id]);
    window['appointmentObj'] = item;
  }

  addItem(){
    this.router.navigate(['/cust-item-subs/' ,+ this.id]);
  }

}
